import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';

@Injectable()
export class ProductosFinancierosService {

  private service_url;

  constructor(
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService,
    private constantsService: ConstantsService, 
    private http: Http,
  ) {
    this.service_url = this.constantsService.apiURL + '/productos-financieros';
   }

  public validate(data){
    console.log("validating... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }
    
    if(!this.validatorService.required(data["rango_monto_min"])){
        error["rango_monto_min"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["rango_monto_max"])){
        error["rango_monto_max"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["tasa"])){
        error["tasa"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["plazo"])){
        error["plazo"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["penalizacion"])){
        error["penalizacion"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["iva"])){
        error["iva"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["tipo_fondeador"])){
        error["tipo_fondeador"] = this.errorService.required;
    }
    if(data["tipo_fondeador"] === "Ahorrador"){
      if(!this.validatorService.required(data["periodicidad"])){
        error["periodicidad"] = this.errorService.required;
      }
    }
    // if(!this.validatorService.required(data["plaza"])){
    //     error["plaza"] = this.errorService.required;
    // }
    
    return error;
  }

  getDefaultSchedule() {
    return {
      'nombre': '',
      'rango_monto_min':'',
      'rango_monto_max':'',
      'tasa': '',
      'plazo': '',
      'penalizacion': '',
      'iva': '',
      'tipo_fondeador': '',
      'periodicidad': ''
    };
  }

  public registrarProductoFinanciero(data) {
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public obtenerProductos(page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }
  //Obtiene todos los productos en general sin paginate
  public getSelect() {
    return this.http.get(this.service_url + '?select=true', this.authService.getAuthHeaders());
  }
  //Productos financieros por tipo de fondeador
  public getSelectTipo(tipoFondeador: string) {
    return this.http.get(this.service_url + '?tipo='+tipoFondeador, this.authService.getAuthHeaders());
  }
  // buscar objeto simple
  search(search, page = null) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.service_url + "?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.service_url + "?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public updateProducto(id, data){
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public delete(id) {
    return this.http.delete(this.service_url +'?id='+ id, this.authService.getAuthHeaders());
  }
  public writePermission() {
    return true;
    //return this.authService.hasPermission(10, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/productos-financieros.service.ts